import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/plans');

export async function getPlansToValidate(chefId) {
  const response = await apiFetch(`${API_BASE}/chef/${chefId}`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des plans assignés');
  }
  return response.json();
}

export async function getTeam() {
  const response = await apiFetch(`${API_BASE}/chefs`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des membres');
  }
  return response.json();
}

export async function getSummary(chefId) {
  const response = await apiFetch(`${API_BASE}/chef/${chefId}`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement du résumé');
  }
  const plans = await response.json();
  const pending = plans.filter((p) => (p.statut || '').toLowerCase() === 'analyse').length;
  const completed = plans.filter((p) => (p.statut || '').toLowerCase() === 'validé').length;
  const revise = plans.filter((p) => (p.statut || '').toLowerCase() === 'correction demandée').length;
  return { pending, completed, revise };
}

export async function getPlanGrilleData(planId) {
  const response = await apiFetch(`${API_BASE}/${planId}/grille-data`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des données de la grille');
  }
  return response.json();
}

export async function updatePlanStatus(planId, statut) {
  const response = await apiFetch(`${API_BASE}/${planId}/status`, {
    method: 'PATCH',
    auth: true,
    json: true,
    body: JSON.stringify({ statut }),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Mise à jour du statut impossible');
  }
  return response.json();
}

export async function saveGrid(planId, chefId, payload) {
  const response = await apiFetch(`${API_BASE}/${planId}/grille`, {
    method: 'POST',
    auth: true,
    json: true,
    body: JSON.stringify({ chef_id: chefId, payload }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || 'Enregistrement de la grille impossible');
  }
  return response.json();
}

export async function submitValidation(payload) {
  return { ok: true, payload };
}

export async function assignPlan(planId, assignee) {
  return { ok: true, planId, assignee };
}
